import { BaseService } from "core/services";
import { FacilityOrderStatusRouteService } from "application/facility-order/services";

class FacilityOrderStatusService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityOrderStatusRouteService());
	}
}

export default FacilityOrderStatusService;